/*
* Add class active on awards menu
*/
document.addEventListener('DOMContentLoaded', function() {
    var links = document.querySelectorAll('.awards-container--menu_item a');
    
    if (links.length > 0) {
      var activeLink = links[0]; // Première lien comme lien actif initial
  
      activeLink.classList.add('active'); // Ajouter la classe "active" au lien actif initial
  
      links.forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault(); // Empêcher le comportement de lien par défaut
  
          activeLink.classList.remove('active'); // Supprimer la classe "active" du lien précédemment actif
          activeLink = this; // Définir le nouveau lien actif
          activeLink.classList.add('active'); // Ajouter la classe "active" au nouveau lien actif
        });
      });
    }
  });


  /*
* Menu fixed on scroll
*/
window.addEventListener('DOMContentLoaded', function() {
    var awardsMenu = document.querySelector('.awards-container--menu');
    var awardsGalleries = document.querySelector('.awards-container--galleries');
    var footer = document.querySelector('footer');
    var menuHeight = 100; // Hauteur du menu sticky en pixels
    var footerThreshold = footer.getBoundingClientRect().top + window.pageYOffset - window.innerHeight;

    function toggleAwardsList() {
        if (!awardsMenu || !awardsMenu.parentElement) {
            return; // Vérifier si awardsMenu existe et a un parent
        }

        var containerRect = awardsMenu.parentElement.getBoundingClientRect();
        var containerTop = containerRect.top;

        if (window.innerWidth >= 1200) {
            if (containerTop <= menuHeight && window.pageYOffset < footerThreshold) {
                awardsMenu.style.position = 'fixed';
                awardsMenu.style.top = menuHeight + 'px';
                //awardsGalleries.style.width = 'calc(100% - 320px)';
                awardsGalleries.style.marginLeft = '280px';
            } else {
                awardsMenu.style.position = 'relative';
                awardsMenu.style.top = '0';
                awardsGalleries.style.width = '100%';
                awardsGalleries.style.marginLeft = '0';
            }
        }
    }

    function checkFooterThreshold() {
        footerThreshold = footer.getBoundingClientRect().top + window.pageYOffset - window.innerHeight;

        if (window.pageYOffset >= footerThreshold) {
            window.addEventListener('scroll', toggleAwardsList);
            window.removeEventListener('scroll', checkFooterThreshold);
        } else {
            toggleAwardsList();
        }
    }

    window.addEventListener('scroll', toggleAwardsList);
    window.addEventListener('scroll', checkFooterThreshold);
});





